export const postcardSmall = {
	name: 'Untitled Small Postcard Template',
	variant: 'design',
	json: {
		width: 1800,
		height: 1200,
		unit: 'px',
		dpi: 300,
		fonts: [],
		pages: [
			{
				id: 'page_1',
				children: [],
				width: 'auto',
				height: 'auto',
				background: 'white',
				bleed: 0,
				custom: {
					name: 'Front',
				},
			},
			{
				id: 'page_2',
				children: [
					{
						id: 'senderAreaUS',
						type: 'figure',
						name: 'Sender Area',
						opacity: 1,
						visible: true,
						selectable: false,
						removable: false,
						alwaysOnTop: true,
						showInExport: true,
						x: 1500,
						y: 900,
						width: 1200,
						height: 900,
						rotation: 0,
						animations: [],
						blurEnabled: false,
						blurRadius: 10,
						brightnessEnabled: false,
						brightness: 0,
						sepiaEnabled: false,
						grayscaleEnabled: false,
						shadowEnabled: false,
						shadowBlur: 5,
						shadowOffsetX: 0,
						shadowOffsetY: 0,
						shadowColor: 'black',
						shadowOpacity: 1,
						draggable: false,
						resizable: false,
						contentEditable: true,
						styleEditable: true,
						subType: 'rect',
						fill: 'rgba(255,255,255,1)',
						dash: [],
						strokeWidth: 0,
						stroke: 'rgba(155,155,155,1)',
						cornerRadius: 0,
					},
					{
						id: 'returnAddressUS',
						type: 'text',
						name: 'Sender Address',
						opacity: 1,
						visible: true,
						selectable: true,
						removable: false,
						alwaysOnTop: true,
						showInExport: true,
						x: 1800,
						y: 1350,
						width: 900,
						height: 100,
						rotation: 0,
						animations: [],
						blurEnabled: false,
						blurRadius: 0,
						brightnessEnabled: false,
						brightness: 0,
						sepiaEnabled: false,
						grayscaleEnabled: false,
						shadowEnabled: false,
						shadowBlur: 0,
						shadowOffsetX: 0,
						shadowOffsetY: 0,
						shadowColor: 'black',
						shadowOpacity: 1,
						draggable: false,
						resizable: false,
						contentEditable: true,
						styleEditable: true,
						text: 'Firstname Lastname\nCity, State Postalcode',
						placeholder: '',
						fontSize: 40,
						fontFamily: 'Roboto',
						fontStyle: 'normal',
						fontWeight: 'normal',
						textDecoration: '',
						fill: 'rgba(0,0,0,1)',
						align: 'justify',
						verticalAlign: 'top',
						strokeWidth: 0,
						stroke: 'black',
						lineHeight: 1.2,
						letterSpacing: 0,
						backgroundEnabled: false,
						backgroundColor: '#7ED321',
						backgroundOpacity: 1,
						backgroundCornerRadius: 0.5,
						backgroundPadding: 0.5,
					},
					{
						id: 'senderLogoUS',
						type: 'image',
						name: 'Sender Logo',
						opacity: 1,
						visible: true,
						selectable: true,
						removable: false,
						alwaysOnTop: true,
						showInExport: true,
						x: 1011.5135135135229,
						y: 975,
						width: 100,
						height: 100,
						rotation: 0,
						animations: [],
						blurEnabled: false,
						blurRadius: 10,
						brightnessEnabled: false,
						brightness: 0,
						sepiaEnabled: false,
						grayscaleEnabled: false,
						shadowEnabled: false,
						shadowBlur: 5,
						shadowOffsetX: 0,
						shadowOffsetY: 0,
						shadowColor: 'black',
						shadowOpacity: 1,
						draggable: false,
						resizable: false,
						contentEditable: true,
						styleEditable: true,
						src: 'https://staging-bay.cdn.bkat.io/services/design/assets/Template-66687d741f5d8781764c296e/e482860dee3f735cabb280df01eca9a992e5f484.png?buster=T6apaJsyRiCr3pNTzhZUow-5657802',
						cropX: 0,
						cropY: 0,
						cropWidth: 1,
						cropHeight: 0.9999999999999979,
						cornerRadius: 0,
						flipX: false,
						flipY: false,
						clipSrc: '',
						borderColor: 'black',
						borderSize: 0,
						keepRatio: false,
					},
					{
						id: 'recipientAddressUS',
						type: 'text',
						name: 'Recipient Address',
						opacity: 1,
						visible: true,
						selectable: false,
						removable: false,
						alwaysOnTop: true,
						showInExport: false,
						x: 1650,
						y: 975,
						width: 600,
						height: 90,
						rotation: 0,
						animations: [],
						blurEnabled: false,
						blurRadius: 10,
						brightnessEnabled: false,
						brightness: 0,
						sepiaEnabled: false,
						grayscaleEnabled: false,
						shadowEnabled: false,
						shadowBlur: 4.956586911258956,
						shadowOffsetX: 0,
						shadowOffsetY: 0,
						shadowColor: 'black',
						shadowOpacity: 1,
						draggable: false,
						resizable: false,
						contentEditable: true,
						styleEditable: true,
						text: 'Recipient Name\nCity, State Postalcode',
						placeholder: '',
						fontSize: 40,
						fontFamily: 'Roboto',
						fontStyle: 'normal',
						fontWeight: 'normal',
						textDecoration: '',
						fill: 'rgba(0,0,0,1)',
						align: 'justify',
						verticalAlign: 'top',
						strokeWidth: 0,
						stroke: 'black',
						lineHeight: 1.2,
						letterSpacing: 0,
						backgroundEnabled: false,
						backgroundColor: '#7ED321',
						backgroundOpacity: 1,
						backgroundCornerRadius: 0.5,
						backgroundPadding: 0.5,
					},
				],
				width: 'auto',
				height: 'auto',
				background: 'white',
				bleed: 0,
				custom: {
					name: 'Back',
					country: 'US',
				},
			},
			{
				id: 'page_3',
				children: [
					{
						id: 'recipientAreaCA',
						type: 'figure',
						name: 'Recipient Area',
						opacity: 1,
						visible: true,
						selectable: false,
						removable: false,
						alwaysOnTop: true,
						showInExport: true,
						x: 1500,
						y: 0,
						width: 1200,
						height: 1800,
						rotation: 0,
						animations: [],
						blurEnabled: false,
						blurRadius: 10,
						brightnessEnabled: false,
						brightness: 0,
						sepiaEnabled: false,
						grayscaleEnabled: false,
						shadowEnabled: false,
						shadowBlur: 5,
						shadowOffsetX: 0,
						shadowOffsetY: 0,
						shadowColor: 'black',
						shadowOpacity: 1,
						draggable: false,
						resizable: false,
						contentEditable: true,
						styleEditable: true,
						subType: 'rect',
						fill: 'rgba(255,255,255,1)',
						dash: [],
						strokeWidth: 0,
						stroke: 'rgba(155,155,155,1)',
						cornerRadius: 0,
					},
					{
						id: 'senderAreaCA',
						type: 'figure',
						name: 'Sender Area',
						opacity: 1,
						visible: true,
						selectable: false,
						removable: false,
						alwaysOnTop: true,
						showInExport: true,
						x: 0,
						y: 0,
						width: 500,
						height: 300,
						rotation: 0,
						animations: [],
						blurEnabled: false,
						blurRadius: 10,
						brightnessEnabled: false,
						brightness: 0,
						sepiaEnabled: false,
						grayscaleEnabled: false,
						shadowEnabled: false,
						shadowBlur: 5,
						shadowOffsetX: 0,
						shadowOffsetY: 0,
						shadowColor: 'black',
						shadowOpacity: 1,
						draggable: false,
						resizable: false,
						contentEditable: true,
						styleEditable: true,
						subType: 'rect',
						fill: 'rgba(255,255,255,1)',
						dash: [],
						strokeWidth: 0,
						stroke: 'rgba(155,155,155,1)',
						cornerRadius: 0,
					},
					{
						id: 'returnAddressCA',
						type: 'text',
						name: '',
						opacity: 1,
						visible: true,
						selectable: true,
						removable: false,
						alwaysOnTop: true,
						showInExport: true,
						x: 100,
						y: 100,
						width: 300,
						height: 100,
						rotation: 0,
						animations: [],
						blurEnabled: false,
						blurRadius: 10,
						brightnessEnabled: false,
						brightness: 0,
						sepiaEnabled: false,
						grayscaleEnabled: false,
						shadowEnabled: false,
						shadowBlur: 4.956586911258956,
						shadowOffsetX: 0,
						shadowOffsetY: 0,
						shadowColor: 'black',
						shadowOpacity: 1,
						draggable: false,
						resizable: false,
						contentEditable: true,
						styleEditable: true,
						text: 'RETURN TO:\nFirstname Lastname\nCity, State Postalcode',
						placeholder: '',
						fontSize: 24,
						fontFamily: 'Roboto',
						fontStyle: 'normal',
						fontWeight: 'normal',
						textDecoration: '',
						fill: 'rgba(0,0,0,1)',
						align: 'justify',
						verticalAlign: 'top',
						strokeWidth: 0,
						stroke: 'black',
						lineHeight: 1.2,
						letterSpacing: 0,
						backgroundEnabled: false,
						backgroundColor: '#7ED321',
						backgroundOpacity: 1,
						backgroundCornerRadius: 0.5,
						backgroundPadding: 0.5,
					},
					{
						id: 'recipientAddressCA',
						type: 'text',
						name: 'Recipient Address',
						opacity: 1,
						visible: true,
						selectable: false,
						removable: false,
						alwaysOnTop: true,
						showInExport: false,
						x: 1750,
						y: 900,
						width: 900,
						height: 100,
						rotation: 0,
						animations: [],
						blurEnabled: false,
						blurRadius: 10,
						brightnessEnabled: false,
						brightness: 0,
						sepiaEnabled: false,
						grayscaleEnabled: false,
						shadowEnabled: false,
						shadowBlur: 4.956586911258956,
						shadowOffsetX: 0,
						shadowOffsetY: 0,
						shadowColor: 'black',
						shadowOpacity: 1,
						draggable: false,
						resizable: false,
						contentEditable: true,
						styleEditable: true,
						text: 'Recipient Name\nCity, State Postalcode',
						placeholder: '',
						fontSize: 40,
						fontFamily: 'Roboto',
						fontStyle: 'normal',
						fontWeight: 'normal',
						textDecoration: '',
						fill: 'rgba(0,0,0,1)',
						align: 'justify',
						verticalAlign: 'top',
						strokeWidth: 0,
						stroke: 'black',
						lineHeight: 1.2,
						letterSpacing: 0,
						backgroundEnabled: false,
						backgroundColor: '#7ED321',
						backgroundOpacity: 1,
						backgroundCornerRadius: 0.5,
						backgroundPadding: 0.5,
					},
				],
				width: 'auto',
				height: 'auto',
				background: 'white',
				bleed: 0,
				custom: {
					name: 'Back',
					country: 'CA',
				},
			},
		],
	},
	status: 'draft',
	history: [],
	tags$Category: ['0:Category:Listing'],
	tags$General: [
		'0:Medium:Print',
		'0:Distribution:Mail',
		'0:Format:Postcard',
		'0:Layout:Landscape',
		'0:Dimensions:6x4',
	],
	etc: {
		directives: {
			senderLogoUS: {
				src: '{{user.logoDarkUrl}}',
			},
			returnAddressUS: {
				text: '{{user.fullName}}\n{{user.city}}, {{user.stateProvince}} {{user.postalCode}}',
			},
			returnAddressCA: {
				text: 'RETURN TO:\n{{user.fullName}}\n{{user.city}}, {{user.stateProvince}} {{user.postalCode}}',
			},
		},
		cfg: {
			global: {
				minPages: 3,
				maxPages: 3,
			},
			customer: {
				minPages: 2,
				maxPages: 2,
			},
			order: {
				countries: ['US', 'CA'],
				itemId: 'postcardSmall',
			},
			pageOrderIsLocked: true, // Prevent the user from changing the order of the pages
			canBeResized: false,
			showGuides: true,
		},
	},
};

export default postcardSmall;
